import CartProductsList from "components/CartProductsList/CartProductsList";

export default CartProductsList;